import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  EcomJobUploadStatusCriteriaBean,
  PageListBean,
  RestEComJobStatusDetailsRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  ShowError,
} from "../gui_components/UIComponents.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ECommerceConnectorService } from "../services/ECommerceConnectorService.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "./BaseModule.js";

class EcomJobStatusDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Ecom Job Status Details",

      isShowClearErrorButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      moduleForPopup: [],
      error_list: [],
      ecomJobStatusDataList: [],

      summaryData: null,
      criteria: new EcomJobUploadStatusCriteriaBean(),
      criteriaViewShow: false,
      pageList: new PageListBean(),
      isEcomJobStatusDataFound: false,
      isShowPageListToolBar: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
  }

  componentDidUpdate() {
    //
  }

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  loadPage = (pageNumber) => {
    this.clearError();
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let listRequest = new RestEComJobStatusDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadEComConnectorJobStatusDetailsList(listRequest);
  };

  loadEComConnectorJobStatusDetailsList = (listRequest) => {
    if (SecurityAccessManager.EcomJobStatusDetails_IsAccessible()) {
      ECommerceConnectorService.getEComConnectorJobStatusDetails(
        listRequest,
        this.loadEComConnectorJobStatusDetailsPageResponse,
        this.loadEComConnectorJobStatusDetailsError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadEComConnectorJobStatusDetailsPageResponse = (response) => {
    const EComConnectorJobStatusDetailsList =
      response.data.responseResut.dataJobList;

    if (EComConnectorJobStatusDetailsList != null) {
      this.setState({
        isEcomJobStatusDataFound: true,
        ecomJobStatusDataList: EComConnectorJobStatusDetailsList,
        isShowPDFButton: false,
        isShowExcelButton: false,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        error_list: errList,
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isEcomJobStatusDataFound: false,
        isShowPageListToolBar: false,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  loadEComConnectorJobStatusDetailsError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  generatePDF = () => {
    //
  };
  generateExcel = () => {
    //
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  clearCriteria = () => {
    let tempCriteria = new EcomJobUploadStatusCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    this.setState({ criteria: tempCriteria });
    this.hideAlertCallBack();
  };

  resetInquiry = () => {
    //
  };

  execute = () => {
    this.setState({
      isLoading: true,
      loadingText: "Executing",
    });
    this.clearError();
    this.loadPage(1);
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage;
    if (currentPage < 1) {
      previousPage = currentPage - 1;
    }
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let nextPage = currentPage;
    if (currentPage > totalPages) {
      nextPage = currentPage + 1;
    }
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  columnDefinitions = () => {
    let columnList = [];
    columnList.push(new DataGridColumnDefinition().setDetails("Job#", "jobId"));
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ProcessedDate",
        "processedDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SubmittedDate",
        "submittedDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Status", "status")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WebsiteType", "websiteType")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("JobType", "jobType")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Remarks", "processRemarks")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("TotalRows", "processedRows", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("SucessRows", "successRows", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("FailureRows", "failureRows", 1)
    );
    return columnList;
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  render() {
    let ecomJobStatusDataList = this.state.ecomJobStatusDataList;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        {this.state.isShowPageListToolBar ? (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null}
        <CriteriaView
          {...this.state}
          // refresh={this.refresh}
          loadPage={this.loadPage}
        />
        {/* {isLoading ? <Loader loadingText="isssss" /> : null} */}
        {this.state.isEcomJobStatusDataFound ? (
          <EditableDataGrid
            columnsList={this.columnDefinitions()}
            dataList={ecomJobStatusDataList}
          />
        ) : null}
      </div>
    );
  }
}

export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  return (
    <div>
      <Row className="d-flex justify-content-around">
        <Col sm="2">
          {/* <Button
          size="sm"
          className="secondary_header_buttons"
          onClick={() => loadPage()}
        >
          Refresh
        </Button>  */}
        </Col>
      </Row>
    </div>
  );
}
function EcomJobStatusModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <EcomJobStatusDetails {...props} name="" /> <br />
    </div>
  );
}

export default EcomJobStatusModule;
